import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import React from 'react'
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useGetShipmentFDDetailQuery, useUpdateShipmentFDMutation } from "store/services/shipmentFulfillmentDocumentApi";
import ShipmentFulfillmentDocumentForm from "./ShipmentFulfillmentDocumentComponents/ShipmentFulfillmentDocumentForm";
import { useAppMeta } from "hooks";

const ShipmentFulfillmentDocumentEditScreen = () => {

    const { id } = useParams();

    const navigate = useNavigate();

    const breadcrumbs = [
        { title: "Shipment Document", path: "/app/crm/collection-document/list" },
        { title: "Edit Shipment Document" },
    ];
    // RTK Query
    const { data: shipmentFDDetail, isLoading: loadingShipmentFD, error, }
        = useGetShipmentFDDetailQuery(id);

    const [updateShipmentFD, { isLoading: updatingShipmentFD }]
        = useUpdateShipmentFDMutation();

    // methods
    const handleUpdateShipmentFD = async (data) => {

        const _payload = data;

        delete _payload.disclaimers;
        try {
            await updateShipmentFD({ ..._payload },).unwrap();
            toast.success("Shipment Document successfully updated!");
            navigate(`/app/crm/collection-document/${id}/detail`);
        } catch (err) {
            toast.error(
                err?.data?.message ?? err?.message ?? "Couldn't update Shipment Document!"
            );
        }
    };

    useAppMeta("Edit Shipment Document");

    return (
        <BreadcrumbLayout
            breadcrumbs={breadcrumbs}
            isBusy={loadingShipmentFD || updatingShipmentFD}
        >
            <BreadcrumbLayout.Error error={error} />

            <BreadcrumbLayout.Paper>
                <ShipmentFulfillmentDocumentForm
                    isBusy={loadingShipmentFD || updatingShipmentFD}
                    shipmentFDDetail={shipmentFDDetail}
                    onSubmit={handleUpdateShipmentFD}
                />
            </BreadcrumbLayout.Paper>
        </BreadcrumbLayout>
    )
}

export default ShipmentFulfillmentDocumentEditScreen